var map = {
	"./ABS.png": 1747,
	"./ATS.png": 5781,
	"./AmplifiID.png": 692,
	"./TextureIcons/blotter_paper.svg": 4258,
	"./TextureIcons/capsule.svg": 7516,
	"./TextureIcons/cooker.svg": 4718,
	"./TextureIcons/crystal.svg": 4496,
	"./TextureIcons/flakes.svg": 8689,
	"./TextureIcons/liquid.svg": 7015,
	"./TextureIcons/other.svg": 7455,
	"./TextureIcons/pebbels2.svg": 8122,
	"./TextureIcons/powder.svg": 2192,
	"./TextureIcons/syringe_residue.svg": 1988,
	"./TextureIcons/tablet.svg": 7419,
	"./TextureIcons/wet_paste.svg": 7745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;